import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Subject } from 'rxjs/Subject';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/operator/switchMap';
import { App } from 'ionic-angular';
import { OauthService } from './oauth.service';
import { Observable } from 'rxjs/Observable';
import { Folder } from '../models/folder/folder.model';
import { Search } from '../models/search/search.model';
import { Folders } from '../models/folder/folder.interface';
import { ToolsService } from './tools.service';
import FolderInterface = Folders.FolderInterface;
import { ResponseMessage } from '../models/responseMessage/responseMessage.model';
import {AppProvider} from "../../core/app/app-provider.service";
import {InfoReglementInterface} from "../models/consommation/infoReglement.interface";

@Injectable()
export class DossierPrestationsService extends OauthService {

  public loader = new Subject<boolean>();

  constructor(
    protected http: Http,
    protected app: App,
    protected appProvider: AppProvider,
    public readonly tools: ToolsService,
  ) {
    super(http, app, appProvider, tools);
    this.loader.next(true); // init custom loader
  }

  /**
   * @param {Search} search
   * @returns {Observable<any>}
   */
  getAll(search: Search): Observable<any> {
    const editedSearch: any = { ...search, ...{ _format: 'json' } };

    const url = this.Routing.generate('api_get_dossier_prestations', editedSearch, true);

    return this.http
      .get(url, { headers: this.updateHeaders() })
      .map(response => response.json());
  }

  getAllHistory(search: Observable<Search> = null) {
    return search.debounceTime(500)
      .distinctUntilChanged()
      .switchMap(s => this.searchAllHistory(s, s.action));
  }

  searchAllHistory(search: Search, action: string) {
    const param = { '_format': 'json' };

    for (const item in search) {
      if (search[item]) {
        param[item] = search[item];
      }
    }

    const url = this.Routing.generate('api_get_dossier_prestations', param, true);

    return this.http
      .get(url, { headers: this.updateHeaders() })
      .map(response => {
        this.loader.next(false); // disable custom loader
        return { data: response.json().data, action };
      });
  }

  /**
   * @param line
   * @param idFolder
   * @returns {Observable<any>}
   */
  addLine(line, idFolder): Observable<any> {
    // const param = { '_format': 'json' };
    const param = { };

    if (idFolder) {
      param['dossierPrestation'] = idFolder;
    }

    const url = this.Routing.generate('api_post_dossierprestation_ligne_add', param, true);
    return this.http
      .post(url, JSON.stringify(line), { headers: this.updateHeaders() })
      .map(response => response.json());
  }

  /**
   * @param line
   * @param idFolder
   * @returns {Observable<any>}
   */
  addLineAndWaiting(line, idFolder): Observable<any> {
    const param = {};

    if (idFolder) {
      param['dossierPrestation'] = idFolder;
    }

    const url = this.Routing.generate('api_post_dossierprestation_ligne_add_and_waiting', param, true);
    return this.http
      .post(url, JSON.stringify(line), { headers: this.updateHeaders() })
      .map(response => response.json());
  }

  // /**
  //  * @param line
  //  * @param idFolder
  //  * @returns {Observable<any>}
  //  */
  // addLineAndValidated(line, idFolder): Observable<any> {
  //   const param = {'_format': 'json'};

  //   if (idFolder) {
  //     param['dossierPrestation'] = idFolder;
  //   }

  //   const url = this.Routing.generate('api_post_dossierprestation_ligne_add_and_validate', param, true);
  //   return this.http
  //     .post(url, JSON.stringify(line), {headers: this.updateHeaders()})
  //     .map(response => response.json());
  // }

  updateLine(folder, idLine, idFolder) {
    const url = this.Routing.generate('api_put_dossierprestation_ligne_edit', {
      '_format': 'json',
      'dossierPrestation': idFolder,
      'ligne': idLine
    }, true);

    return this.http
      .put(url, JSON.stringify(folder), { headers: this.updateHeaders() })
      .map(response => response.json());
  }

  updateLineRemarques(values, idLine, idFolder) {
    const url = this.Routing.generate('api_patch_dossierprestation_ligne_remarques', {
      '_format': 'json',
      'dossierPrestation': idFolder,
      'ligne': idLine
    }, true);

    return this.http
      .patch(url, JSON.stringify(values), { headers: this.updateHeaders() })
      .map(response => response.json());
  }
  updateRemarques(values, idFolder) {
    const url = this.Routing.generate('api_patch_dossier_prestation_remarques', {
      '_format': 'json',
      'dossierPrestation': idFolder
    }, true);

    return this.http
      .patch(url, JSON.stringify(values), { headers: this.updateHeaders() })
      .map(response => response.json());
  }

  getAmount(folder: Observable<any> = null) {
    return folder.debounceTime(500)
      .distinctUntilChanged()
      .switchMap(f => this.getApiAmount(f));
  }

  getApiAmount(folder: any) {
    const param = {};

    for (const item in folder) {
      if (folder[item]) {
        param[item] = folder[item];
      }
    }

    const url = this.Routing.generate('api_get_dossierprestation_ligne_subvention', param, true);

    return this.http
      .get(url, { headers: this.updateHeaders() })
      .map(response => {
        this.loader.next(false); // disable custom loader
        return response.json().data;
      });
  }

  updateStatus(status) {
    const url = this.Routing.generate('api_put_dossier_prestation_status_update', { '_format': 'json' }, true);

    return this.http
      .put(url, JSON.stringify(status), { headers: this.updateHeaders() })
      .map(response => response.json());
  }

  getDossierPrestations(dossierPrestationId: number): Observable<FolderInterface> {
    const url = this.Routing.generate('api_get_dossier_prestation', {
      '_format': 'json',
      dossierPrestation: dossierPrestationId
    }, true);

    return this.http
      .get(url, { headers: this.updateHeaders() })
      .map(response => {
        // this.loader.next(false); // enable custom loader
        return response.json().data;
      });
  }

  getAvailablePayments(folder: Folder): Observable<Array<any>> {
    const data = {
      '_format': 'json',
      dossierPrestation: folder.id
    };

    const url = this.Routing.generate('api_get_dossier_prestation_payment', data, true);

    return this.http
      .get(url, { headers: this.updateHeaders() })
      .map(response => {
        return response.json().data;
      });
  }

  deleteLineDossierPrestations(idLine, idFolder) {
    const url = this.Routing.generate('api_delete_dossier_prestation_line', {
      '_format': 'json',
      'dossierPrestation': idFolder,
      'ligne': idLine
    }, true);

    return this.http
      .delete(url, { headers: this.updateHeaders('beneficiaire') })
      .map(response => {
        return response;
      });
  }

  createDossierPrestations(idFolder) {
    const url = this.Routing.generate('api_post_dossier_prestation_creation', {
      '_format': 'json',
      'dossierPrestation': idFolder,
    }, true);

    return this.http
      .post(url, JSON.stringify({}), { headers: this.updateHeaders('beneficiaire') })
      .map(response => response.json());
  }

  validateDossierPrestations(idFolder) {
    const url = this.Routing.generate('api_post_dossier_prestation_validation', {
      '_format': 'json',
      'dossierPrestation': idFolder,
    }, true);

    return this.http
      .post(`${url}`, JSON.stringify({ facturer: 1 }), { headers: this.updateHeaders('beneficiaire') })
      .map(response => response.json());
  }

  invoiceDossierPrestations(idFolder) {
    const url = this.Routing.generate('api_post_dossier_prestation_facturation', {
      '_format': 'json',
      'dossierPrestation': idFolder
    }, true);

    return this.http
      .post(`${url}`, JSON.stringify({ facturer: 1 }), { headers: this.updateHeaders('beneficiaire') })
      .map(response => response.json());
  }

  updateDate(dates, folder) {
    const url = this.Routing.generate('api_patch_dossier_prestation_date', {
      '_format': 'json',
      'dossierPrestation': folder
    }, true);

    return this.http
      .patch(url, JSON.stringify(dates), { headers: this.updateHeaders() })
      .map(response => response.json());
  }

  updateDateReference(dates, folder) {
    const url = this.Routing.generate('api_patch_dossier_prestation_date_reference', {
      '_format': 'json',
      'dossierPrestation': folder
    }, true);

    return this.http
      .patch(url, JSON.stringify(dates), { headers: this.updateHeaders() })
      .map(response => response.json());
  }

  getLineAttachments(idLine, idFolder) {
    const url = this.Routing.generate('api_get_dossier_prestations_pj', {
      '_format': 'json',
      'dossierPrestation': idFolder,
      'ligne': idLine
    }, true);
    return this.http
      .get(url, { headers: this.updateHeaders('beneficiaire') })
      .map(response => response.json());
  }

  addLineAttachment(idLine, idFolder, file) {
    console.log('attachment', file);
    // Construct form data for the API
    const formData = {
      'ligneCommande': idLine.toString(),
      'file': file,
    };

    const url = this.Routing.generate('api_post_dossier_prestation_pj', {
      '_format': 'json',
      'dossierPrestation': idFolder
    }, true);

    return this.http
      .post(url, formData, { headers: this.updateHeaders('upload') })
      .map(response => response.json());
  }

  deleteLineAttachment(idLine, idFolder, idAttachment) {
    const url = this.Routing.generate('api_delete_dossier_prestation_pj', {
      '_format': 'json',
      'dossierPrestation': idFolder,
      'ligne': idLine,
      'pieceJointe': idAttachment,
    }, true);
    return this.http
      .delete(url, { headers: this.updateHeaders('beneficiaire') })
      .map(response => response.json());
  }

  public delete(id: number): Observable<ResponseMessage> {
    const url = this.Routing.generate('api_delete_dossier_prestation', {
      '_format': 'json',
      'dossier': id
    }, true);

    return this.http
      .delete(url, {headers: this.updateHeaders('beneficiaire')})
      .map(response => {
        return response.json();
      });
  }

  getReglement(idDossier: number): Observable<Array<InfoReglementInterface>> {
    const data = {
      '_format': 'json',
      dossierPrestation: idDossier
    };

    const url = this.Routing.generate('api_get_dossier_prestation_reglement', data, true);

    return this.http
      .get(url, { headers: this.updateHeaders() })
      .map(response => {return response.json().data;});
  }
}



// WEBPACK FOOTER //
// ./src/shared/services/dossierPrestations.service.ts